export const LocationStatusId = {
    Active: 1,
    Purged: 2,
    Inactive: 3,
};
